const workingCalendar = {
    'TITLE': 'Working Calendar',
    'CREATE': 'Create',
    'IMPORT': 'Import',
    'EXPORT': 'Export',
    'PARTNER_NAME': 'Partner Name',
    'TYPE': 'Type',
    'WORKING_DAYS': 'Working Days',
    'NON_WORKING_DAYS': 'Non-Working Days',
    'HOLIDAY_CALENDAR': 'Holiday Calendar',
    'STATUS': 'Status',
    'UPDATE_BY': 'Update By',
    'UPDATE_AT': 'Update At',
    'ACTION': 'Action',
    'ACTIVE': 'Active',
    'INACTIVE': 'Inactive',
    'HOLIDAYS': 'holidays',
    'SEARCH': 'Search',
    'TYPE_PLACEHOLDER': 'Type',
    'CREATE_TITLE': 'Create Working Calendar',
    'EDIT_TITLE': 'Edit Working Calendar',
    'GENERAL_INFO': 'General Information',
    'ADD_HOLIDAY': 'Add Holiday',
    'HOLIDAY_NAME': 'Holiday Name',
    'DATE': 'Date',
    'REPEAT_YEARLY': 'Repeat Yearly',
    'YES': 'Yes',
    'SELECT_PLACEHOLDER': 'Select...',
    'DATE_RANGE_PLACEHOLDER': 'dd/mm/yyyy - dd/mm/yyyy',
    'INPUT_PLACEHOLDER': 'Input...',
    'SAVE_ROW': 'Save',
    'NO': 'No',
};

export default workingCalendar;
